export default __webpack_public_path__ + "static/media/group-set.fc8962eb.svg";